module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.products), function(product) {
    return _c('li', {
      key: product.id
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": ("/product/" + (product.id))
      }
    }, [_c('div', {
      staticClass: "products-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.host + product.figures.big,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v("see in catalog")])])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(product.terms.name[_vm.$t("trad")].value))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18e04613","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_module/products-catalog.vue
// module id = 3040
// module chunks = 0